import { NgModule, Component, Input, ChangeDetectionStrategy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { TypeformService } from 'angular-engine/engine/service/util/typeform.service';

@Component({
    selector: 'content-builder',
    templateUrl: 'content-builder.template.html',
    styleUrls: ['content-builder.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentBuilder {
    @Input() items: any;
    //@Input() content: any = {};
    private isServer:boolean;

    private defaultImage = 'thumb_640x';
    private settings: any = {
        imageType: this.defaultImage,
        clickEnable: false
    };

    constructor(@Inject(PLATFORM_ID) private platformId: string,
    private typeformService: TypeformService) { 
        this.isServer = isPlatformServer(this.platformId);
    }

    ngOnInit() {

    }

    ngAfterViewInit() {
        if(!this.isServer)
        {
            this.typeformService.renderTypeforms(window);
        }
    }

    private getSpotlightContent(row: any): Observable<any> {
        return Observable.create(observer => {
            var result = [];
            row.items.forEach((item) => {
                if (item.type === "image") {
                    // assign image details
                    result.push({ type: item.type, images: item.content_images, alt: item.alt_text });
                }
                else if (item.type === "pull_quote") {
                    result.push({ type: item.type, title: `${item.source}, ${item.source_title}`, copy: item.content });
                }
                else if (item.type === "text"){
                    result.push({ type: item.type, copy: item.content });
                }
                else if (item.type === "html"){
                    result.push({ type: item.type, html: item.content });
                }
            });

            observer.next(result);
            observer.complete();
        });
    }

    private size(item): string {
        return item.length > 1 ? "col-md-6 col-xs-12" : "col-xs-12";
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/content-builder/content-builder.component.ts